import React, { createContext, useContext } from 'react';
import 'core-js/actual/array/flat-map';
import * as PropTypes from 'prop-types';
import { createOrder, getTransactionDetails } from 'src/services/payment-gateway.service';
import { SalesforceContext, AcquiringChannelFlags } from './salesforce-context';
import { vatPercent } from 'src/helpers/constants';
import TealiumEvents from '../helpers/tealium-events';

export const PaymentGatewayContext = createContext();

export function PaymentGatewayProvider({ children }) {
  const { merchant, getDeviceOrderQuantity, customerType, lead } = useContext(SalesforceContext);

  const getDeliveriesToDisplay = () =>
    (merchant?.opportunity &&
      Object.values(merchant.opportunity.deliveries).filter(
        (delivery) => delivery.number_of_devices > 0,
      )) ||
    [];

  const reserveFunds = async (isRetry = false) => {
    const totalToBePaid = getDeliveriesToDisplay()
      .map((delivery) => {
        const priceExclVAT =
          delivery.acquiring_channel === AcquiringChannelFlags.buyOnlineFicaOnline
            ? delivery.price * getDeviceOrderQuantity(delivery.device_id)
            : 0;
        const VAT = priceExclVAT * vatPercent;
        return priceExclVAT + VAT;
      })
      .reduce((a, b) => a + b, 0);

    const mobileNumber = merchant?.contact?.phone;
    const idNumber = merchant?.contact?.id_number;
    const orderID = await createOrder(mobileNumber, idNumber, totalToBePaid);
    if (orderID) {
      const res = await getTransactionDetails(orderID);
      if (res) {
        const paymentGatewayUrl = res.formAttributes.action;
        if (isRetry) {
          TealiumEvents.reserveFundsRetryButtonClick(paymentGatewayUrl, customerType);
        } else {
          const assistantId = lead.dealerId || lead.agentId || '';
          TealiumEvents.reserveFundsConfirmButtonClick(
            paymentGatewayUrl,
            customerType,
            assistantId,
          );
        }
        redirectToPaymentGateway(res, orderID);
      }
    }
  };

  const redirectToPaymentGateway = (data) => {
    let postParams = data.formInputFields;

    let paymentGatewayForm = document.createElement('FORM');
    paymentGatewayForm.method = 'post';
    paymentGatewayForm.name = 'ucf';
    paymentGatewayForm.id = 'ucf';
    paymentGatewayForm.type = 'HIDDEN';
    paymentGatewayForm.action = data.formAttributes.action;
    paymentGatewayForm.target = '_self';

    for (let i = 0; i < postParams.length; i++) {
      let inputElement = document.createElement('INPUT');
      inputElement.type = postParams[i].type || 'HIDDEN';
      inputElement.name = postParams[i].name;
      inputElement.id = postParams[i].id;
      inputElement.value = postParams[i].value;
      paymentGatewayForm.appendChild(inputElement);
    }

    document.body.appendChild(paymentGatewayForm);
    paymentGatewayForm.submit();
  };

  return (
    <PaymentGatewayContext.Provider
      value={{
        reserveFunds,
      }}
    >
      {children}
    </PaymentGatewayContext.Provider>
  );
}

PaymentGatewayProvider.propTypes = { children: PropTypes.any };
